export const filtersSelector = (state) => state.filters || {};
const getFilters = (state, filterBlockName) => filtersSelector(state)[filterBlockName] || {};

export default {
  getFilters,
  getFiltersByFilterName: (state, blockName, filterName) => getFilters(state, blockName)[filterName],
};
